import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { collectionsClient } from '#pplx_generated/typespec/rest/collections/client.js';
export const upsertThreadCollection = async ({ params, reason, }) => {
    try {
        const { data, error, response } = await collectionsClient.POST('/rest/collections/upsert_thread_collection', reason, {
            body: params,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to upsert thread collection',
                cause: error,
                status: response.status ?? 0,
            });
        }
        // Unfortunately the backend Pydantic types are nowhere near good and return Record<string, unknown> for the most part
        return data;
    }
    catch {
        return undefined;
    }
};
//# sourceMappingURL=upsertThreadCollection.js.map